import { render, staticRenderFns } from "./ArchiveReturn.vue?vue&type=template&id=2ea08b9e&"
import script from "./ArchiveReturn.vue?vue&type=script&lang=js&"
export * from "./ArchiveReturn.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveReturn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveReturn.vue"
export default component.exports